import Dashboard from 'domain/entity/dashboard';
import { Result } from 'domain/types';
import {
    UpdateDashboardAccessClient,
    UpdateDashboardNameClient,
    UpdateDashboardPinClient,
    UpdateDashboardStarClient,
} from 'use-case/dashboard/update/updateDashboardClient';
import { UpdateDashboardAccessCriteria } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardAccessCriteria';
import { UpdateDashboardNameCriteria } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardNameCriteria';
import { UpdateDashboardPinCriteria } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardPinCritera';
import { UpdateDashboardStarCriteria } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardStarCriteria';

export type UpdateDashboardResult = Result<Dashboard>;
export type UpdateDashboardName = (criteria: UpdateDashboardNameCriteria) => Promise<UpdateDashboardResult>;
export type UpdateDashboardStar = (criteria: UpdateDashboardStarCriteria) => Promise<UpdateDashboardResult>;
export type UpdateDashboardAccess = (criteria: UpdateDashboardAccessCriteria) => Promise<UpdateDashboardResult>;
export type UpdateDashboardPin = (criteria: UpdateDashboardPinCriteria) => Promise<UpdateDashboardResult>;

export const updateDashboardNameUseCase = (updateDashboardNameClient: UpdateDashboardNameClient): UpdateDashboardName => (
    criteria: UpdateDashboardNameCriteria
): Promise<UpdateDashboardResult> => updateDashboardNameClient(criteria);

export const updateDashboardStarUseCase = (updateDashboardStarClient: UpdateDashboardStarClient): UpdateDashboardStar => (
    criteria: UpdateDashboardStarCriteria
): Promise<UpdateDashboardResult> => updateDashboardStarClient(criteria);

export const updateDashboardAccessUseCase = (updateDashboardAccessClient: UpdateDashboardAccessClient): UpdateDashboardAccess => (
    criteria: UpdateDashboardAccessCriteria
): Promise<UpdateDashboardResult> => updateDashboardAccessClient(criteria);

export const updateDashboardPinUseCase = (updateDashboardAccessClient: UpdateDashboardPinClient): UpdateDashboardPin => (
    criteria: UpdateDashboardPinCriteria
): Promise<UpdateDashboardResult> => updateDashboardAccessClient(criteria);
